import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { SbomService } from '../../../Services/sbom.service';
import { CustomerService } from '../../../Services/customer.service';
import { SbomProject, SbomProjectStatus, SbomProjectStatusLabels, HASH_ALGORITHMS } from '../../../Models/sbom.model';
import { Customer } from '../../../Models/customer.model';

@Component({
  selector: 'app-sbom-project-form',
  templateUrl: './sbom-project-form.component.html',
  styleUrls: ['./sbom-project-form.component.css']
})
export class SbomProjectFormComponent implements OnInit {
  project: Partial<SbomProject>;
  isEdit: boolean;
  saving = false;
  customers: Customer[] = [];
  statusOptions = Object.values(SbomProjectStatus);
  statusLabels = SbomProjectStatusLabels;
  hashAlgorithms = HASH_ALGORITHMS;

  constructor(
    public dialogRef: MatDialogRef<SbomProjectFormComponent>,
    @Inject(MAT_DIALOG_DATA) public data: SbomProject | null,
    private sbomService: SbomService,
    private customerService: CustomerService
  ) {
    this.isEdit = !!data?.id;
    this.project = data ? { ...data } : {
      name: '',
      description: '',
      customerId: 0,
      status: SbomProjectStatus.InPlanung,
      projectNumber: '',
      plcType: '',
      plcFirmwareVersion: '',
      projectHash: '',
      hashAlgorithm: '',
      notes: ''
    };
  }

  ngOnInit(): void {
    this.customerService.getCustomers().subscribe({
      next: (customers) => this.customers = customers ?? []
    });
  }

  save(): void {
    if (!this.project.name?.trim() || !this.project.customerId) return;
    this.saving = true;

    const payload = {
      name: this.project.name,
      description: this.project.description,
      customerId: this.project.customerId,
      status: this.project.status,
      projectNumber: this.project.projectNumber,
      plcType: this.project.plcType,
      plcFirmwareVersion: this.project.plcFirmwareVersion,
      projectHash: this.project.projectHash,
      hashAlgorithm: this.project.hashAlgorithm,
      handoverDate: this.project.handoverDate,
      notes: this.project.notes
    };

    if (this.isEdit) {
      this.sbomService.updateProject(this.data!.id, payload).subscribe({
        next: () => { this.saving = false; this.dialogRef.close(true); },
        error: () => { this.saving = false; }
      });
    } else {
      this.sbomService.createProject(payload).subscribe({
        next: () => { this.saving = false; this.dialogRef.close(true); },
        error: () => { this.saving = false; }
      });
    }
  }

  cancel(): void {
    this.dialogRef.close(false);
  }
}
